import { useQuery } from '@tanstack/react-query';

import type { ReleasesResponse } from '@/types'; // <-- Make sure to import ReleasesResponse

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

interface ReleasesParams {
  page?: number;
}

const useGetReleases = (params?: ReleasesParams) => {
  return useQuery<ReleasesResponse>({
    queryKey: ['releases', params],

    queryFn: async (): Promise<ReleasesResponse> => {
      const { page } = params || {};

      const { data } = await axiosInstance.get<ReleasesResponse>(
        API_ROUTES.publishedReleases(page, 10)
      );

      return data;
    },
    gcTime: 0,
    staleTime: 0,
  });
};

export default useGetReleases;
